<template>
  <div class="h-100 d-block">
    <b-table
      class="h-100 d-flex"
      striped
      hover
      responsive
      bordered
      :fields="fields"
      :items="dataList"
      small
    >
      <template #cell(count)="data">
        {{ data.item.count | toNumber }}
      </template>
      <template #cell(accessories_percent)="data">
        <b-button
          :id="'popover-accPercent-' + data.item.id"
          variant="link"
          class="p-0 m-0 text-body font-weight-normal"
        >
          <div
            :class="goalsClass(data.item.accessories_percent)"
            class="font-weight-bold d-flex align-items-center justify-content-end"
          >
            %{{ data.item.accessories_percent | toNumber }}
          </div>
        </b-button>
        <b-popover
          :target="'popover-accPercent-' + data.item.id"
          triggers="hover"
          placement="left"
        >
          <div
            class="d-flex align-items-center w-100 justify-content-center"
            style="margin-top: 5px"
          >
            <div class="text-center pr-1 border-right">
              <div class="text-primary font-weight-bold font-small-2">
                Hedef
              </div>
              <div>{{ data.item.accessories_goals | toNumber }}₺</div>
            </div>
            <div class="text-center pl-1">
              <div class="text-primary font-weight-bold font-small-2">
                Ciro
              </div>
              <div>{{ data.item.accessories_turnover | toNumber }}₺</div>
            </div>
          </div>
        </b-popover>
      </template>
      <template #cell(tire_percent)="data">
        <b-button
          :id="'popover-tirePercent-' + data.item.id"
          variant="link"
          class="p-0 m-0 text-body font-weight-normal"
        >
          <div
            :class="goalsClass(data.item.tire_percent)"
            class="font-weight-bold d-flex align-items-center justify-content-end"
          >
            %{{ data.item.tire_percent | toNumber }}
          </div>
        </b-button>
        <b-popover
          :target="'popover-tirePercent-' + data.item.id"
          triggers="hover"
          placement="left"
        >
          <div
            class="d-flex align-items-center justify-content-center"
            style="margin-top: 5px"
          >
            <div class="text-center pr-1 border-right">
              <div class="text-primary font-weight-bold font-small-2">
                Hedef
              </div>
              <div>{{ data.item.tire_goals | toNumber }}</div>
            </div>
            <div class="text-center pl-1">
              <div class="text-primary font-weight-bold font-small-2">
                Ciro
              </div>
              <div>{{ data.item.tire_turnover | toNumber }}</div>
            </div>
          </div>
        </b-popover>
      </template>
      <template #cell(paint_protection_percent)="data">
        <b-button
          :id="'popover-paintPercent-' + data.item.id"
          variant="link"
          class="p-0 m-0 text-body font-weight-normal"
        >
          <div
            :class="goalsClass(data.item.paint_protection_percent)"
            class="font-weight-bold d-flex align-items-center justify-content-end"
          >
            %{{ data.item.paint_protection_percent | toNumber }}
          </div>
        </b-button>
        <b-popover
          :target="'popover-paintPercent-' + data.item.id"
          triggers="hover"
          placement="left"
        >
          <div
            class="d-flex align-items-center justify-content-center"
            style="margin-top: 5px"
          >
            <div class="text-center pr-1 border-right">
              <div class="text-primary font-weight-bold font-small-2">
                Hedef
              </div>
              <div>{{ data.item.paint_protection_goals | toNumber }}</div>
            </div>
            <div class="text-center pl-1">
              <div class="text-primary font-weight-bold font-small-2">
                Ciro
              </div>
              <div>{{ data.item.paint_protection_turnover | toNumber }}</div>
            </div>
          </div>
        </b-popover>
      </template>
      <template #cell(total_turnovers)="data">
        {{ data.item.total_turnovers | toNumber }}₺
      </template>
    </b-table>
  </div>
</template>
<script>
import {
  BTable, BButton, VBPopover, BPopover,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  name: 'TableGoals',
  components: {
    BTable,
    BButton,
    BPopover,
  },
  directives: {
    'b-popover': VBPopover,
    Ripple,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'brand',
          label: 'Marka',
          sortable: true,
          thClass: 'font-small-2 align-middle',
          tdClass: 'font-weight-bold text-body',
        },
        {
          key: 'count',
          label: 'Servis Araç Giriş',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-body',
        },
        {
          key: 'accessories_percent',
          label: 'Aksesuar Hedef %',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'tire_percent',
          label: 'Lastik Hedef %',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'paint_protection_percent',
          label: 'Boya Koruma Hedef %',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'total_turnovers',
          label: 'Toplam Ciro',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle',
          tdClass: 'text-right text-nowrap text-body',
        },
      ],
    }
  },
  methods: {
    goalsClass(val) {
      let className = ''
      if (val === 0) {
        className = 'text-danger'
      } else if (val > 0 && val < 50) {
        className = 'text-warning'
      } else if (val > 50 && val < 75) {
        className = 'text-info'
      } else if (val > 75) {
        className = 'text-success'
      }
      return className
    },
  },
}
</script>
